import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import InputFieldText from '../../../../../components/input/floating-label/input-field/InputFieldText';
import {
  clearSuchvorschlaege,
  getAdressenByParam,
} from '../../../../../redux/actions/adresse';
import { AutocompleteFormatPLZ } from '../search/AutocompleteFormatPLZ';
import { AutocompleteFormatFremdnummer } from '../search/AutocompleteFormatFremdnummer';
import { AutocompleteFormatName } from '../search/AutocompleteFormatName';
import {
  findAdresseByTyp,
  getGridCellActiveComponentLabel,
  NACHNAHME_EMPFAENGER,
  VERSENDER,
} from '../AdresseTypen';
import {
  StateModel,
  StateModel_Auftragserfassung,
} from '../../../../../redux/store';
import { Adresse, Auftrag, Land } from '../../../../../api';
import { nameof } from '../../../../../utils/objectUtils';
import { AutocompleteFormatOrtsname } from '../../../adresserfassung/anschrift/search/AutocompleteFormatOrtsname';
import {
  getLaender,
  searchLaender,
} from '../../../../../redux/actions/laender';
import { searchOrte } from '../../../../../redux/actions/orte';
import Button from '../../../../../components/button/Button';
import { createAdresse } from '../../../../../redux/actions/adresserfassung';
import { setNotificationField } from '../../../../../redux/actions/notification';
import Form from '../../../../../components/form/Form';
import { toSelectOptions } from '../../../../../components/select/SelectModel';
import Select from '../../../../../components/select/Select';
import { LandModel } from '../../../../../models/LandModel';
import { History } from 'history';
import { ConfigModel } from '../../../../../models/ConfigModel';

interface AdresseFelderProps {
  auftragserfassung: StateModel_Auftragserfassung;
  stammdaten: any;
  addressType: string;
  setAdresse: (addressType: string, value: any, key: string) => void;
  adresse?: Adresse;
  getAdressenByParam: (
    mandantId: number,
    fremdnummer: string,
    name: string,
    lkz: string,
    plz: string,
    ortsname: string,
    strasse: string
  ) => void;
  isCreate: boolean;
  setIsCreate?: (value: boolean) => void;
  searchOrte: (ortsname?: string, plz?: string, landId?: number) => void;
  createAdresse: (
    adresse: any,
    copyid?: number | undefined,
    history?: History,
    onSuccessHandler?: () => void
  ) => void;
  setNotificationField: (value: any, fieldName: string) => void;
  getLaender: () => void;
  laender: LandModel[];
  currentMandantId: string;
  config: ConfigModel;
}

const AdresseFelder = ({
  auftragserfassung,
  addressType,
  setAdresse,
  adresse,
  getAdressenByParam,
  isCreate,
  setIsCreate,
  searchOrte,
  stammdaten,
  createAdresse,
  setNotificationField,
  getLaender,
  laender,
  currentMandantId,
  config,
}: AdresseFelderProps) => {
  const suchLabelText = 'Name/Suchbegriff eingeben z.B.: Müller 1010';
  const nameLabelText = 'Name';
  const [id, setId] = useState<number | null>(
    adresse ? adresse.id ?? null : null
  );

  const [matchcode, setMatchcode] = useState(
    adresse ? adresse.matchcode ?? '' : ''
  );
  const [fremdnummer, setFremdnummer] = useState(
    adresse ? adresse.fremdnummer ?? '' : ''
  );
  const [name, setName] = useState(adresse ? adresse.name ?? '' : '');
  const [nameLabel, setNameLabel] = useState(
    adresse?.name ? nameLabelText : suchLabelText
  );
  const [strasse, setStrasse] = useState(adresse ? adresse.strasse ?? '' : '');

  const [hausnummer, setHausnummer] = useState(
    adresse ? adresse.hausnummer ?? '' : ''
  );
  const [selectedLand, setSelectedLand] = useState<Land | undefined>(
    adresse && adresse.land
  );
  // adresse && adresse.land ? adresse.land.lkz ?? '' : ''
  const [plz, setPlz] = useState<string>((adresse && adresse.plz) ?? '');
  const [ort, setOrt] = useState<string>((adresse && adresse.ort) ?? '');
  const [kontakt, setKontakt] = useState(adresse?.kontakt ?? '');
  const [telefon, setTelefon] = useState(adresse?.telefon ?? '');
  const [email, setEmail] = useState('');
  const [focusedField, setFocusedField] = useState('');
  const [currentAdressType, setCurrentAdressType] = useState(addressType);
  const [kurzname, setKurzname] = useState(adresse?.kurzname ?? '');
  const [zeile2, setZeile2] = useState(adresse?.zeile2 ?? '');
  const [zeile3, setZeile3] = useState(adresse?.zeile3 ?? '');
  const [inUebertragung, setInUebertragung] = useState(
    adresse?.inUebertragung ?? false
  );
  const [mailTrackTrace, setMailTrackTrace] = useState(
    adresse?.mailTrackTrace ?? ''
  );
  const [mandant, setMandant] = useState(adresse ? adresse.mandant ?? '' : '');

  const [usteuerid, setUsteuerid] = useState(
    adresse ? adresse.usteuerid ?? '' : ''
  );
  const [postfach, setPostfach] = useState(
    adresse ? adresse.postfach ?? '' : ''
  );

  const [ortPostfach, setOrtPostfach] = useState(
    adresse ? adresse.ortPostfach ?? '' : ''
  );
  const [einmaladr, setEinmaladr] = useState(
    adresse ? adresse.einmaladresse ?? '' : ''
  );
  const [unsichtbar, setUnsichtbar] = useState(
    adresse ? adresse.unsichtbar ?? '' : ''
  );
  const [ortsteil, setOrtsteil] = useState(
    adresse ? adresse.ortsteil ?? '' : ''
  );

  const [zusatz, setZusatz] = useState(adresse ? adresse.zusatz ?? '' : '');
  const isBexity = config.clientKunde?.toUpperCase() === 'BEXITY';

  const resetToDefault = () => {
    setId(null);
    setMatchcode('');
    setFremdnummer('');
    setName('');
    setStrasse('');
    setHausnummer('');
    setSelectedLand({ lkz: '', bezeichnung: '' });
    setPlz('');
    setOrt('');
    setKontakt('');
    setTelefon('');
    setEmail('');
    setKurzname('');
    setZeile2('');
    setZeile3('');
    setInUebertragung(false);
    setMailTrackTrace('');
    setMandant('');
    setKurzname('');
    setUsteuerid('');
    setZeile3('');
    setZusatz('');
    setOrtsteil('');
    setPostfach('');
    setOrtPostfach('');
    setEinmaladr(false);
    setUnsichtbar(false);
  };

  useEffect(() => {
    const tmp = findAdresseByTyp(auftragserfassung.adressen, addressType);
    if (Object.keys(tmp).length > 0) {
      id !== tmp.id && setId(tmp.id ?? null);
      matchcode !== tmp.matchcode && setMatchcode(tmp.matchcode ?? '');
      fremdnummer !== tmp.fremdnummer && setFremdnummer(tmp.fremdnummer ?? '');
      name !== tmp.name && setName(tmp.name ?? '');
      zeile2 !== tmp.zeile2 && setZeile2(tmp.zeile2 ?? '');
      zeile3 !== tmp.zeile3 && setZeile3(tmp.zeile3 ?? '');
      strasse !== tmp.strasse && setStrasse(tmp.strasse ?? '');
      hausnummer !== tmp.hausnummer && setHausnummer(tmp.hausnummer ?? '');
      if (tmp.lkz && selectedLand?.lkz !== tmp?.lkz && tmp.id != null) {
        setSelectedLand(tmp?.land?.id ? tmp.land : undefined);
      }
      plz !== tmp.plz && setPlz(tmp.plz ?? '');
      ort !== tmp.ort && setOrt(tmp.ort ?? '');
      kontakt !== tmp.kontakt && setKontakt(tmp.kontakt ?? '');
      telefon !== tmp.telefon && setTelefon(tmp.telefon ?? '');
      inUebertragung != tmp.inUebertragung &&
        tmp.id != null &&
        setInUebertragung(tmp.inUebertragung);
      setCurrentAdressType(addressType);
      if (adresse?.id && adresse?.matchcode && isCreate && setIsCreate) {
        setIsCreate(false);
      }
    }
  }, [currentAdressType, adresse]);

  useEffect(() => {
    setSelectedLand(adresse?.land);
  }, [adresse?.land]);

  useEffect(() => {
    setAdresse(addressType, id, 'id');
  }, [id]);

  useEffect(() => {
    if (
      (focusedField === 'absenderAdresse' ||
        focusedField === 'empfaengerAdresse') &&
      !isCreate
    )
      getAdressenByParam(
        currentMandantId
          ? Number(currentMandantId)
          : auftragserfassung.mandant?.id ?? -1,
        fremdnummer,
        name,
        selectedLand?.lkz ?? '',
        plz,
        ort,
        strasse
      );

    setAdresse(addressType, fremdnummer, 'fremdnummer');
  }, [fremdnummer]);

  useEffect(() => {
    if (isCreate) {
      setAdresse(addressType, false, nameof<Adresse>('inUebertragung'));
    }
  }, [isCreate]);

  useEffect(() => {
    if (focusedField === 'name' && !isCreate)
      getAdressenByParam(
        currentMandantId
          ? Number(currentMandantId)
          : auftragserfassung.mandant?.id ?? -1,
        fremdnummer,
        name,
        selectedLand?.lkz ?? '',
        plz,
        ort,
        strasse
      );
    setAdresse(addressType, name, 'name');
  }, [name]);

  useEffect(() => {
    if (focusedField === 'strasse' && !isCreate)
      getAdressenByParam(
        currentMandantId
          ? Number(currentMandantId)
          : auftragserfassung.mandant?.id ?? -1,
        fremdnummer,
        name,
        selectedLand?.lkz ?? '',
        plz,
        ort,
        strasse
      );

    setAdresse(addressType, strasse, 'strasse');
  }, [strasse]);

  useEffect(() => {
    setAdresse(addressType, hausnummer, 'hausnummer');
  }, [hausnummer]);

  useEffect(() => {
    setAdresse(addressType, selectedLand, 'lkz');
  }, [selectedLand]);

  useEffect(() => {
    isCreate && searchOrte(ort, plz, adresse?.land?.id);
    setAdresse(addressType, plz, 'plz');
  }, [plz]);

  useEffect(() => {
    isCreate && searchOrte(ort, plz);
    setAdresse(addressType, ort, 'ort');
  }, [ort]);

  useEffect(() => {
    setAdresse(addressType, kurzname, 'kurzname');
  }, [kurzname]);

  useEffect(() => {
    setAdresse(addressType, kontakt, 'kontakt');
  }, [kontakt]);

  useEffect(() => {
    setAdresse(addressType, telefon, 'telefon');
  }, [telefon]);

  useEffect(() => {
    setAdresse(addressType, email, 'email');
  }, [email]);

  useEffect(() => {
    setAdresse(addressType, zeile2, 'zeile2');
  }, [zeile2]);

  useEffect(() => {
    setAdresse(addressType, inUebertragung, nameof<Adresse>('inUebertragung'));
  }, [inUebertragung]);

  useEffect(() => {
    setAdresse(addressType, mailTrackTrace, 'mailTrackTrace');
  }, [mailTrackTrace]);

  useEffect(() => {
    getLaender();
  }, []);

  useEffect(() => {
    setAdresse(addressType, einmaladr, 'einmaladr');
  }, [einmaladr]);

  useEffect(() => {
    setAdresse(addressType, unsichtbar, 'unsichtbar');
  }, [unsichtbar]);

  useEffect(() => {
    setAdresse(addressType, zusatz, 'zusatz');
  }, [zusatz]);

  useEffect(() => {
    setAdresse(addressType, postfach, 'postfach');
  }, [postfach]);

  useEffect(() => {
    setAdresse(addressType, ortPostfach, 'ortPostfach');
  }, [ortPostfach]);

  useEffect(() => {
    setAdresse(addressType, matchcode, 'matchcode');
  }, [matchcode]);

  useEffect(() => {
    setAdresse(addressType, mandant, 'mandant');
  }, [mandant]);

  useEffect(() => {
    setAdresse(addressType, zeile3, 'zeile3');
  }, [zeile3]);

  useEffect(() => {
    setAdresse(addressType, usteuerid, 'usteuerid');
  }, [usteuerid]);

  useEffect(() => {
    setAdresse(addressType, kurzname, 'kurzname');
  }, [kurzname]);

  useEffect(() => {
    setAdresse(addressType, ortsteil, 'ortsteil');
  }, [ortsteil]);

  /**
   * AutocompleteHandler PLZ für die Adressenanlage
   * @param suchvorschlag
   */
  const autocompleteHandlerPLZ = (suchvorschlag: any) => {
    setPlz(suchvorschlag['plz']);
    setOrt(suchvorschlag['ortsname']);
    setSelectedLand(laender.filter(land => land.lkz === suchvorschlag.lkz)[0]);
  };

  const autocompleteHandlerAdresse = (suchvorschlag: any) => {
    setMatchcode(suchvorschlag['matchcode']);
    setFremdnummer(suchvorschlag['fremdnummer']);
    setName(suchvorschlag[`name`]);
    setZeile2(suchvorschlag[`zeile2`]);
    setStrasse(suchvorschlag[`strasse`]);
    setHausnummer(suchvorschlag[`hausnummer`]);
    setSelectedLand(suchvorschlag[`land`]);
    setPlz(suchvorschlag[`plz`]);
    setOrt(suchvorschlag[`ort`]);
    setId(suchvorschlag[`id`]);
    setTelefon(suchvorschlag['telefon']);
    setKontakt(suchvorschlag['kontakt']);
    setInUebertragung(suchvorschlag['inUebertragung']);
    setMailTrackTrace(suchvorschlag['mailTrackTrace']);
    setUsteuerid(suchvorschlag['usteuerid']);
    setMandant(suchvorschlag['mandant']);
    setZusatz(suchvorschlag['zusatz']);
    setOrtsteil(suchvorschlag['ortsteil']);
    setPostfach(suchvorschlag['postfach']);
    setOrtPostfach(suchvorschlag['ortPostfach']);
    setEinmaladr(suchvorschlag['einmaladresse']);
    setUnsichtbar(suchvorschlag['unsichtbar']);
    setZeile3(suchvorschlag[`zeile3`]);
    setKurzname(suchvorschlag[`kurzname`]);
  };

  const fremdnummerOnChangeHandler = (value: string) => {
    setFremdnummer(value);
    if (value === '' && !isCreate) resetToDefault();
  };

  const nameOnChangeHandler = (name: string) => {
    if (isCreate) {
      setName(name);
      setNameLabel(nameLabelText);
    } else {
      resetToDefault();
      setName(name);
      if (name.length === 0) {
        setNameLabel(suchLabelText);
      } else {
        setNameLabel(nameLabelText);
      }
    }
  };

  const onCreateAdresseSuccess = () => {
    if (setIsCreate) {
      setIsCreate(false);
    }
  };

  function getSenderAdressIsReadOnly() {
    //Die Absenderadresse muss änderbar sein! Bei Fragen bitte an SBiT if (currentAdressType == VERSENDER && !isCreate) return true;
    return currentAdressType == VERSENDER && config.isAbsenderEditDeny;
  }
  if (
    currentAdressType != NACHNAHME_EMPFAENGER ||
    (isBexity && currentAdressType === NACHNAHME_EMPFAENGER)
  ) {
    return (
      <Form classes='adresse'>
        <div id='matchcode-kurzname'>
          <InputFieldText
            label='Nummer'
            name={nameof<Auftrag>(
              addressType == 'versender'
                ? 'absenderAdresse'
                : 'empfaengerAdresse'
            )}
            classes='matchcode'
            onChangeHandler={fremdnummerOnChangeHandler}
            value={fremdnummer}
            suchvorschlaege={!isCreate && auftragserfassung.suchvorschlaege}
            autocompleteFormat={!isCreate && <AutocompleteFormatFremdnummer />}
            autocompleteHandler={!isCreate && autocompleteHandlerAdresse}
            parentFocusHandler={setFocusedField}
            readonly={getSenderAdressIsReadOnly()}
          />
          <InputFieldText
            label={nameLabel}
            name={nameof<Adresse>('name')}
            classes='name'
            value={name}
            maxlength={35}
            onChangeHandler={nameOnChangeHandler}
            autocompleteFormat={!isCreate && <AutocompleteFormatName />}
            autocompleteHandler={!isCreate && autocompleteHandlerAdresse}
            suchvorschlaege={!isCreate && auftragserfassung.suchvorschlaege}
            parentFocusHandler={setFocusedField}
            readonly={getSenderAdressIsReadOnly()}
            activeNotificationComponent={addressType}
          />
        </div>
        <div id='zeile2'>
          <InputFieldText
            label='Zeile 2'
            name={nameof<Adresse>('zeile2')}
            maxlength={35}
            classes='zeile2'
            onChangeHandler={setZeile2}
            value={zeile2}
            parentFocusHandler={setFocusedField}
            readonly={!isCreate}
            activeNotificationComponent={addressType}
          />
        </div>
        <div id='strasse-hausnummer'>
          <InputFieldText
            label='Straße'
            name={nameof<Adresse>('strasse')}
            maxlength={35}
            classes='strasse'
            onChangeHandler={setStrasse}
            value={strasse}
            parentFocusHandler={setFocusedField}
            readonly={!isCreate}
            activeNotificationComponent={addressType}
          />
          <InputFieldText
            label='Hausnummer'
            name='hausnummer'
            classes='hausnummer'
            maxlength={10}
            onChangeHandler={setHausnummer}
            value={hausnummer}
            readonly={!isCreate}
            activeNotificationComponent={addressType}
          />
        </div>
        <div id='lkz-plz-ort'>
          <Select
            className='lkz'
            headerTitle='LKZ'
            name={nameof<Adresse>('lkz')}
            onChangeHandler={(id?: number) => {
              const land = stammdaten.laender.find(
                (land: any) => land.id === id
              );
              setSelectedLand(land);
            }}
            selectedOptionId={selectedLand?.id}
            selectData={toSelectOptions(
              stammdaten.laender,
              nameof<Land>('lkz'),
              false
            )}
            readonly={!isCreate}
          />
          <InputFieldText
            label='PLZ'
            name={nameof<Adresse>('plz')}
            maxlength={9}
            classes='plz'
            onChangeHandler={setPlz}
            autocompleteFormat={<AutocompleteFormatPLZ />}
            autocompleteHandler={autocompleteHandlerPLZ}
            suchvorschlaege={
              !isCreate
                ? auftragserfassung.suchvorschlaege
                : stammdaten.suchvorschlaege
            }
            value={plz}
            parentFocusHandler={setFocusedField}
            readonly={!isCreate}
            activeNotificationComponent={addressType}
          />
          <InputFieldText
            label='Ort'
            name={nameof<Adresse>('ort')}
            maxlength={35}
            classes='ort'
            onChangeHandler={setOrt}
            autocompleteFormat={<AutocompleteFormatOrtsname />}
            autocompleteHandler={autocompleteHandlerPLZ}
            suchvorschlaege={
              !isCreate
                ? auftragserfassung.suchvorschlaege
                : stammdaten.suchvorschlaege
            }
            value={ort}
            parentFocusHandler={setFocusedField}
            readonly={!isCreate}
            activeNotificationComponent={addressType}
          />
        </div>

        <InputFieldText
          label='Kontakt'
          classes='kontakt'
          inputType='text'
          onChangeHandler={setKontakt}
          maxlength={100}
          value={kontakt}
          readonly={
            getSenderAdressIsReadOnly() ||
            (!isCreate && !config.isAdresseKontaktEdit) ||
            (adresse?.inUebertragung && !config.isAdresseKontaktEdit) ||
            (!isCreate && adresse?.id == undefined)
          }
        />
        {/* Telefonnummern sind strings in keinem bestimmten Format, da in der DB teilweise
          auch Hinweise o.ä. zur Telefonnummer im Feld 'telefon' hinterlegt sind */}
        <InputFieldText
          label={isBexity ? 'Tel.Nr., eMail, Website' : 'Telefon'}
          classes='telefon'
          inputType='text'
          maxlength={50}
          onChangeHandler={setTelefon}
          value={telefon}
          parentFocusHandler={setFocusedField}
          readonly={
            getSenderAdressIsReadOnly() ||
            (!isCreate && !config.isAdresseTelefonEdit) ||
            (adresse?.inUebertragung && !config.isAdresseTelefonEdit) ||
            (!isCreate && adresse?.id == undefined)
          }
        />
        {isCreate && (
          <Button
            classes={'adresseAnlegen'}
            onClickHandler={() => {
              setNotificationField(
                getGridCellActiveComponentLabel(addressType),
                'activeComponent'
              );
              createAdresse(
                findAdresseByTyp(auftragserfassung.adressen, addressType),
                undefined,
                undefined,
                onCreateAdresseSuccess
              );
            }}
          >
            Adresse anlegen
          </Button>
        )}
      </Form>
    );
  } else return <Form classes='adresse'> </Form>;
};

const mapStateToProps = (state: StateModel) => ({
  auftragserfassung: state.Auftragserfassung,
  stammdaten: state.Stammdaten,
  laender: state.Stammdaten.laender,
  currentMandantId: state.UserSession.currentMandantId,
  config: state.Config,
});

export default connect(mapStateToProps, {
  getAdressenByParam,
  searchOrte,
  clearSuchvorschlaege,
  searchLaender,
  createAdresse,
  setNotificationField,
  getLaender,
})(AdresseFelder);
